"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
const material_1 = require("@mui/material");
const StyledBox = (0, material_1.styled)(material_1.Box)(({ theme }) => ({
    display: 'flex',
    gap: '5px',
    position: 'static',
    transform: 'none',
    textTransform: 'uppercase',
    fontWeight: theme.typography.tsFontWeight.bold,
    fontSize: theme.typography.pxToRem(theme.typography.tsFontSize.mini),
    whiteSpace: 'nowrap',
    wordWrap: 'normal',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: `${theme.palette.common.black} !important`,
    padding: '5px',
    backgroundColor: 'hsla(90, 3%, 84%, 1)',
    justifyContent: 'space-between',
    ...(globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
        ? {
            fontSize: theme.typography.tsFontSize.verySmall,
            fontWeight: theme.typography.tsFontWeight.default,
            color: 'black',
            border: '1px solid #979797',
            display: 'flex',
        }
        : {}),
}));
const SimpleTag = ({ id = '', label = '', onClick } = {}) => {
    const onClose = () => {
        if (!onClick) {
            return;
        }
        onClick(id, label);
    };
    return ((0, jsx_runtime_1.jsxs)(StyledBox, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "inherit", title: label, style: {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    ...(globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                        ? {
                            padding: '5px 10px',
                        }
                        : {}),
                }, children: label }), onClick && ((0, jsx_runtime_1.jsx)(Close_1.default, { id: id, "data-testid": id, onClick: onClose, "ts-variant": "labelCloseIcon", fontSize: "medium", style: { marginLeft: '5px', alignSelf: 'center', color: 'black' } }))] }));
};
exports.default = SimpleTag;
